export default "__VITE_ASSET__DCuKD46O__"